const viewAny = (permissions) => {
  return permissions.includes('read-counties')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-counties')
}

const update = (permissions, county) => {
  return hasPermission(permissions, 'update-counties')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  hasPermission,
};